import $ from 'jquery'

function init () {
  let marker = $('.accordion-start-marker')
  let faqMarker = $('.accordion-faq')
  let $markerBros = marker.parent().children()
  checkBefore($markerBros)
  marker.each(createAccordion)
  if (marker.length > 0) {
    removeMarker()
    setLines()
    $(window).trigger('accordion-finished')
  } else if (faqMarker.length > 0) {
    setLines()
  }
}

function checkBefore (children) {
  let start_end = []
  let object = []

  children.each(function () {
    let $this = $(this)
    if ($this.hasClass('accordion-start-marker')) {
      start_end.push('start')
      object.push($this)
    } else if ($this.hasClass('accordion-end-marker')) {
      start_end.push('end')
      object.push($this)
    }
  })

  $.each(start_end, function (i, value) {
    if (value == 'start') {
      if (start_end[i + 1] != null && start_end[i + 1] == 'start') {
        object[i].addClass('outside-start')
      }
    } else if (value == 'end') {
      if (start_end[i - 1] == 'end') {
        object[i].addClass('outside-end')
      }
    }
  })
}

function createAccordion (i, start) {
  const $start = $(start),
    $accordionContainer = $start.prev(),
    $accordionBody = $accordionContainer.find('.js-accordion-body')

  let classes = $start.attr('class')
  let $content

  if (classes == 'accordion-start-marker outside-start') {
    $content = $start.nextUntil('.outside-end')
    $content.each(function () {
      let $this = $(this)
      if ($this.hasClass('accordion')) {
        $this.addClass('top-minus')
      }
    })
  } else {
    $content = $start.nextUntil('.accordion-end-marker')
  }

  $content.each((i, el) => {
    $(el).appendTo($accordionBody).show() //script in accordion end hides all elements first, so show
  })

}

function removeMarker () {
  $('.accordion-start-marker').remove()
  $('.accordion-end-marker').remove()
}

function setLines () {
  $('.accordion').each((index, element) => {
    if (!$(element).next().hasClass('accordion')) {
      const html = `<div class="container last">
                        <div class="row align-content-center">
                            <div class="col-10 offset-1 col-sm-12 offset-sm-0 accordion-cursor">
                                <div class="accordion-wrapper">
                                    <div class="d-flex align-content-center align-items-center js-accordion-head justify-content-between">
                                        <p class="copy accordion-copy d-inline-block"></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>`
      $(element).append(html)
    }
  })
}

export default {
  init
}
